import { useState } from 'react'
import { ThemeProvider } from 'styled-components'

import { Icon20 } from 'builder/components/Icon'
import { CategoryIds } from '../CategoryTabs'
import { componentsMap, iconsMap } from './config'
import { useGetProgress } from './hooks/useGetProgress'
import useProgressTrackerTab from './hooks/useProgressTrackerTab'

import { ProgressModal } from './ProgressModal/ProgressModal'

import {
  ExpandButton,
  NavHeading,
  NavHeadingContainer,
  NavigationContainer,
  NavList,
  NavListItem,
  ProgressBarContainer,
  ProgressBarFiller,
  ServiceHeader,
  ServiceInfo,
  PTContainer,
  WidgetContainer,
  ContentContainer,
  ButtonContainer,
} from './styles'
export const ProgressTracker = ({ categoryId }: { categoryId: CategoryIds }) => {
  const [openProgressModal, setOpenProgressModal] = useState(false)
  const { data: progressData } = useGetProgress()
  const { data, activeServiceId, setActiveServiceId, selectedService } = useProgressTrackerTab(
    categoryId,
    progressData,
  )

  const Widget = componentsMap[selectedService?.component ?? '_'] ?? componentsMap._

  return (
    <PTContainer>
      <NavigationContainer>
        <NavHeadingContainer>
          <ContentContainer />
          <NavHeading>PROGRESS</NavHeading>
          <ButtonContainer>
            <ExpandButton onClick={() => setOpenProgressModal(!openProgressModal)}>
              <Icon20.ExpandNew />
            </ExpandButton>
          </ButtonContainer>
        </NavHeadingContainer>
        <NavList>
          {data.map(service => {
            const isActive = activeServiceId === service.id
            const Icon = iconsMap[service?.icon ?? '_']

            return (
              <ThemeProvider key={service.id} theme={service.theme}>
                <NavListItem isActive={isActive} onClick={() => setActiveServiceId(service.id)}>
                  <Icon alt={service.title} />
                  <ServiceInfo>
                    <ServiceHeader>
                      <span>{service.title}</span>
                      <span>{service.progress}%</span>
                    </ServiceHeader>
                    <ProgressBarContainer isActive={isActive}>
                      <ProgressBarFiller progress={service.progress} />
                    </ProgressBarContainer>
                  </ServiceInfo>
                </NavListItem>
              </ThemeProvider>
            )
          })}
        </NavList>
      </NavigationContainer>

      <WidgetContainer>
        <Widget service={selectedService} />
      </WidgetContainer>
      {openProgressModal && (
        <ProgressModal onClose={() => setOpenProgressModal(false)} progressData={progressData} />
      )}
    </PTContainer>
  )
}
